import { Stack } from "@mui/material";
import { Drawer } from "components";
import { RichTreeView, TreeNode } from "components/tree";
import React, { useEffect, useMemo, useState } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import {
  customerFolderTreeNodes,
  centralFolderTreeNodes,
  setKbFolderTree,
} from "../store/kbStore";
import { useGetKbDirectoryTree } from "controller";

export const KbFileListDrawer = ({
  title = "Move to",
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonText,
  onClose,
  open,
  selectedValues,
}: {
  title: string;
  onPrimaryButtonClick: (item: string[]) => void;
  primaryButtonText?: string;
  onSecondaryButtonClick: () => void;
  onClose: () => void;
  open: boolean;
  selectedValues: string[];
}) => {
  const [selectedFolder, setSelectedFolder] = useState<string[]>([]);
  const { data: kbFolderTree } = useGetKbDirectoryTree();
  const customerFolderTreeNodesFn = useAtomValue(customerFolderTreeNodes);
  const setKbFolderTreeFn = useSetAtom(setKbFolderTree);

  const centralFolderTreeNodesFn = useAtomValue(centralFolderTreeNodes);

  useEffect(() => {
    if (kbFolderTree) {
      setKbFolderTreeFn(kbFolderTree);
    }
  }, [kbFolderTree]);

  const filteredAllKbList = useMemo(() => {
    const filteredCentralKbList = centralFolderTreeNodesFn?.filter(
      (node: TreeNode) => node.type === "folder",
    );
    const filteredCustomerKbList = customerFolderTreeNodesFn?.filter(
      (node: TreeNode) => node.type === "folder",
    );
    return [...filteredCentralKbList, ...filteredCustomerKbList];
  }, [centralFolderTreeNodesFn, customerFolderTreeNodesFn]);

  useEffect(() => {
    setSelectedFolder(selectedValues);
  }, [selectedValues]);
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      primaryButtonText={primaryButtonText || "Select"}
      secondaryButtonText="Cancel"
      onPrimaryButtonClick={() => {
        onPrimaryButtonClick(selectedFolder);
      }}
      onSecondaryButtonClick={() => {
        setSelectedFolder([]);
        onSecondaryButtonClick();
      }}
    >
      <Stack sx={{ width: "400px", p: "24px" }}>
        <RichTreeView
          enableSearch
          searchPlaceholder="Search"
          nodes={filteredAllKbList || []}
          value={selectedFolder}
          onNodeClick={(node) => {
            if (node.type === "file") {
              //   navigate(`/app/kb/document/${node.id}`);
            }
          }}
          onChange={(nextValue: string[], id) => {
            setSelectedFolder([id]);
            console.log(nextValue);
          }}
        />
      </Stack>
    </Drawer>
  );
};
